import { amountToDisplayValue } from '@billy/design-system'
import { Callout } from '@shinetools/lumen-react'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

interface TrialBalanceControlCalloutProps {
  imbalance: number
}

export const TrialBalanceControlCallout = ({ imbalance }: TrialBalanceControlCalloutProps): ReactElement => {
  const { t } = useTranslation()

  return (
    <Callout
      color="danger"
      message={t('expert_trial_balance.control.unbalanced', {
        amount: amountToDisplayValue(Math.abs(imbalance)),
      })}
      role="status"
    />
  )
}
